<template>
  <div>
    <div>
      <h2>Search and add a pin</h2>
      <label>
        <gmap-autocomplete
          @place_changed="setPlace">
        </gmap-autocomplete>
        <button @click="addMarker">Add</button>
      </label>
      <br/>

    </div>
    <br>
    <gmap-map
      :center="center"
      :zoom="2.75"
      style="width:100%;  height: 650px;"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :clickable="true"
        :draggable="true"
        @click="center=m.position"
      ></gmap-marker>
    </gmap-map>

    <!-- {{ jobs }} -->
    <div v-for="job in jobs" :key="job.id" style="" class="mt-2">
      <p style="font-size: 22px; font-weight: 600; color: #E80000; margin-bottom: 0.25rem;" class="mt-4">{{ job.title }}</p>
      <p style="margin-bottom: 0rem;">{{ job.company }}</p>
      <p style="font-size: 18px; font-weight: 400; color: #999;">{{ job.city }}, {{ job.provincestate }}, {{ job.country_selector }} </p>
      <!-- <p>({{ job.job_latitude }}, {{ job.job_longitude }})</p> -->
      <!-- <hr> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "GoogleMap",
  data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      // center: { lat: 45.508, lng: -73.587 },
      center: { lat: 20.0, lng: 0.0 },
      markers: [],
      places: [],
      currentPlace: null,

      jobs: [],
    };
  },

  mounted() {
    // this.geolocate();
    this.getJobs();
  },

  methods: {
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    getJobs () {
      axios.get('/api/jobs/?agency=4')
        .then(res => {
          console.log(res)
          this.jobs = res.data

          for (var job in res.data) {
            // console.log(res.data[job])
            const marker = {
              lat: res.data[job].job_latitude,
              lng: res.data[job].job_longitude
            };
            this.markers.push({ position: marker });
          }
        })
        .catch(error => console.log(error))
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/GoogleMap.vue